// Background image functions
let _this = (module.exports = {
	// Set the dom elements
	dom: {
		bgs: document.querySelectorAll('[data-mobile-image]'),
	},

	// Set variables
	vars: {
		flag: {},
		breakpoints: {
			desktop: parseInt(window.themeConfig?.mobile_breakpoint ?? 768),
		},
	},

	/**
	 * Init functions
	 */
	init: function () {
		// Change the bacground image by the screen resolution
		_this.changeBgImgByScreenResolution();

		// Add resize event listener
		window.addEventListener('resize', _this.resizeHandler);
	},

	/**
	 * Throttle function
	 * @param {Function} fn
	 * @param {Int} wait
	 * @param {String} key
	 * @returns
	 */
	throttle: function (fn, wait, key = 'default') {
		if (!_this.vars.flag[key]) {
			fn();
			_this.vars.flag[key] = true;

			// Set throttle time
			setTimeout(() => {
				_this.vars.flag[key] = false;
			}, wait);
		}
	},

	/**
	 * Resize event handler
	 * @param {Event} evt
	 * @returns
	 */
	resizeHandler: function () {
		// Change the bacground image by the screen resolution
		_this.changeBgImgByScreenResolution();
	},

	/**
	 * Show the desktop/mobile image by the screen resolution
	 */
	changeBgImgByScreenResolution: function () {
		if (_this.dom.bgs && _this.dom.bgs.length) {
			var width = window.innerWidth;
			var attrChain;

			if (width >= _this.vars.breakpoints.desktop) {
				attrChain = ['data-desktop-image', 'data-mobile-image'];
			} else {
				attrChain = ['data-mobile-image', 'data-desktop-image'];
			}

			_this.dom.bgs.forEach(function (bg) {
				// Use the first attribute available on the element, in priority order
				var attr = attrChain.find(function (candidate) {
					return bg.hasAttribute(candidate);
				});

				var imgUrl = attr && bg.getAttribute(attr);
				if (imgUrl) {
					bg.style.backgroundImage = 'url("' + imgUrl + '")';
				}
			});
		}
	},
});
